import { HOST_URL } from "./env";
import { SITE_INDEXING_ENABLED } from "./features";

export const generateRobotsTxt = () => `
# Allow all crawlers
User-agent: *
Allow: /

# Sitemaps${
	// Return a non-crawlable robots.txt in non-production environments
	SITE_INDEXING_ENABLED
		? `
Sitemap: ${HOST_URL}/sitemap.xml
Sitemap: ${HOST_URL}/events/sitemaps/index.xml
Sitemap: ${HOST_URL}/hosts/sitemaps/index.xml
`
		: `
# Sitemap is Disabled
		`
}`;
